export function isMagazine(item) {
    return item?.type === "Magazine";
}
export function isPrintedMagazine(item) {
    return item?.type === "PrintedMagazine";
}
export function isMagazineDeposit(item) {
    return !!item && item.type === "MagazineDeposit";
}
export function isMagazineDoubleDeposit(item) {
    return !!item && item.type === "MagazineDoubleDeposit";
}
//# sourceMappingURL=magazine.js.map